import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';

export interface DeleteContactParams {
	readonly id: string;
}

@Injectable({ providedIn: 'root' })
export class DeleteContactApiMutation extends ApiMutation<
	string,
	DeleteContactParams
> {
	client = 'iam';
	document = gql`
		mutation DeleteContact($id: UUID!) {
			deleteContact(id: $id)
		}
	`;
	method = 'deleteContact';
}
